<template>
  <!--<div class="pt-5 pb-8">
    <o-alert
      :title="paragraph.name"
      variant="info"
      show
    >
      <p class="text-sm">
        {{ paragraph.content }}
      </p>
    </o-alert>
  </div>-->

  <div class="py-5 text-gray-800 dark:text-gray-100">
    <h4 class="text-lg font-semibold">
      {{ paragraph.name }}
    </h4>
    <p class="text-sm  whitespace-pre-line" v-html="paragraph.content" />
  </div>
</template>

<script setup lang="ts">
import {
  OAlert,
} from '@/components/elements'

interface Props {
  paragraph: Record<string, any>
}

defineProps<Props>()
</script>
